<template>
	<el-drawer
		:title="title"
		:visible.sync="visible"
		:append-to-body="true"
		size="1000px"
		:before-close="handleClose"
		:wrapperClosable="false"
		class="my-cust-class"
	>
		<div class="yx-background-color p-16" style="min-height: 100%">
			<div class="body radius-8 p-16">
				<div class="font-h4-regular">
					您已选择
					<span class="yx-color-orange-2 font-h2-regular">{{ sample_sns.length }}</span>
					个样品订单，其中
					<span class="yx-color-orange-2 font-h2-regular">{{ unqualified_count }}</span>
					个不符合拒绝要求
				</div>
				<div class="mt-32">
					<div class="flex-row-align-center">
						<div class="font-h4-regular" style="width: 138px">拒绝原因</div>
						<div class="flex-row-align-center">
							<div
								class="reason flex-row-align-center flex-just-between radius-4 cursor-pointer font-h4-regular font-bold"
								:class="{ active: type === 'onekey' }"
								@click="switchType('onekey')"
							>
								一键填写拒绝原因
								<el-radio v-model="type" label="onekey">{{ '' }}</el-radio>
							</div>
							<div
								class="ml-24 reason flex-row-align-center flex-just-between radius-4 cursor-pointer font-h4-regular font-bold"
								:class="{ active: type === 'single' }"
								@click="switchType('single')"
							>
								分别填写拒绝原因
								<el-radio v-model="type" label="single">{{ '' }}</el-radio>
							</div>
						</div>
					</div>
					<div class="mt-20 flex-row flex-align-start" v-show="type === 'onekey'">
						<div class="font-h4-regular" style="width: 138px">一键填写拒绝原因</div>
						<div class="flex-column">
							<el-input
								style="width: 555px"
								type="textarea"
								placeholder="请填写批量拒绝发货原因"
								v-model="textarea"
								maxlength="300"
								:rows="3"
								show-word-limit
							></el-input>
							<span class="yx-color-text-secondary font-h6-regular">您在这里填写的拒绝发货原因，将对当前所有选中的样品生效</span>
						</div>
					</div>
				</div>
				<div class="mt-20 radius-4 yx-border">
					<el-table :data="list" class="" v-loading="loading" :header-cell-style="{ background: '#F0F1F5', color: '#4E596A', fontSize: '14px' }">
						<el-table-column label="样品订单号" width="180">
							<template slot-scope="{ row }">
								<span>{{ row.sample_sn }}</span>
							</template>
						</el-table-column>
						<el-table-column label="商品信息" align="center" min-width="250">
							<template slot-scope="{ row }">
								<div class="flex-row-align-center">
									<div class="shop_img">
										<el-image style="width: 56px; height: 56px; border-radius: 4px" :src="row.product_pic">
											<template v-slot:error>
												<img src="@/assets/public/img-empty1.png" alt="" />
											</template>
										</el-image>
									</div>
									<div class="ml-10 PingFang font-h6-regular">
										<p class="line-ellipsis-1">{{ row.product_name }}</p>
										<span class="color-gy-7">商品ID {{ row.product_id }}</span>
									</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column label="合作达人" min-width="224">
							<template slot-scope="{ row }">
								<div class="flex-row-align-center">
									<yx-avatar :size="40" class="mr-8" :src="row.anchor_head"></yx-avatar>
									<div>
										<div class="flex-row-align-center">
											<platform-icon v-if="row.anchor_name" style="flex-shrink: 0" :platformId="row.platform_id" />
											<div v-if="row.anchor_name" class="ml-4 color-gy-9 font-h6-medium">{{ row.anchor_name }}</div>
											<div v-else class="color-gy-9 font-h6-medium">无达人信息</div>
										</div>
										<div v-if="row.anchor_name" class="color-gy-7 font-h6-regular">
											{{ row.platform_id | formatPlatformName('unify') }}：{{ row.anchor_id }}
										</div>
										<div v-else class="color-gy-7 font-h6-regular">团长名称： {{ row.institution_name }}</div>
									</div>
								</div>
							</template>
						</el-table-column>
						<el-table-column v-if="showSingle" label="拒绝原因" min-width="100px" prop="operates" width="256">
							<template slot-scope="{ row }">
								<el-input
									v-if="row.is_refuse"
									:type="textarea1"
									resize="none"
									placeholder="请输入拒绝原因"
									v-model="row.refuse_delivery_content"
									:autosize="{ minRows: 1, maxRows: 2 }"
								></el-input>
								<div v-else class="font-h4-regular yx-color-danger">{{ row.reason }}</div>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
			<div style="margin-bottom: 53px"></div>
		</div>
		<div class="drawer-footer">
			<el-button @click="handleClose">取 消</el-button>
			<el-button :disabled="showConfirm" type="primary" @click="confirm" :loading="btnLoading">确认</el-button>
		</div>
	</el-drawer>
</template>
<script>
import { debounce } from 'lodash';
import { batchRejectList, batchRejectShipment } from '@/api/sampleOrder';
export default {
	props: {},
	data() {
		return {
			title: '批量拒绝发货', // 弹窗标题
			visible: false, // 弹窗显隐
			list: [], // 列表数据
			loading: false, // 表格加载状态
			btnLoading: false, // 按钮loading
			type: 'onekey', // 单选框
			textarea: '', // 输入框
			sample_sns: [], // 样品订单号
			unqualified_count: 0, // 不能拒绝条数
			showSingle: false, // 是否显示单选框
			// 强制触发el-input计算高度方法，使单个拒绝原因输入框最小高度为1行
			textarea1: '',
		};
	},
	computed: {
		showConfirm({ list }) {
			return list.some(obj => obj?.refuse_delivery_content === '');
		},
	},
	created() {},
	watch: {
		textarea: debounce(function (val) {
			this.list = this.list.map(obj => (obj.is_refuse ? { ...obj, refuse_delivery_content: val } : obj));
		}, 500),
	},
	mounted() {},
	methods: {
		// 主动显示弹窗
		show(row) {
			this.sample_sns = row.map(item => item.sample_sn);
			this.getListData();
			this.visible = true;
		},
		switchType(type) {
			this.textarea1 = '';
			this.loading = true;
			this.type = type;
			this.showSingle = this.type === 'single';
			if (type === 'onekey') {
				this.list = this.list.map(obj => (obj.is_refuse ? { ...obj, refuse_delivery_content: this.textarea } : obj));
			}
			setTimeout(() => {
				this.textarea1 = 'textarea';
				this.loading = false;
			}, 300);
		},
		// 获取表格列表数据
		async getListData() {
			// 列表loading状态开启
			this.loading = true;
			try {
				const { list, unqualified_count } = await batchRejectList({ sample_sns: this.sample_sns });
				this.unqualified_count = unqualified_count;
				this.list = list.map(obj => (obj.is_refuse ? { ...obj, refuse_delivery_content: '' } : obj));
			} catch (error) {
				this.list = [];
			} finally {
				// 列表loading状态关闭
				this.loading = false;
			}
		},
		// 清空数据并关闭弹窗
		handleClose() {
			// 清空数据
			this.list = [];
			this.loading = false;
			this.btnLoading = false;
			this.type = 'onekey';
			this.showSingle = false;
			this.textarea = '';
			// 关闭弹窗
			this.visible = false;
		},
		// 确认按钮点击事件
		confirm: debounce(async function () {
			// 按钮loading开启
			this.btnLoading = true;
			try {
				// 刷新列表（外部重新获取数据）
				const sample = this.list
					.filter(obj => obj.is_refuse)
					.map(({ refuse_delivery_content, sample_sn }) => ({ refuse_delivery_content, sample_sn }));
				const { code } = await batchRejectShipment({ sample: sample });
				if (code === 0) {
					this.$message.success('操作成功');
					this.$emit('refresh');
					// 完成之后清空数据
					this.handleClose();
				}
			} finally {
				// 按钮loading开启
				this.btnLoading = false;
			}
		}, 300),
	},
	components: {},
	beforeDestroy() {},
};
</script>

<style lang="less" scoped>
.my-cust-class {
	::v-deep {
		.el-dialog__body {
			padding-top: 0;
			background-color: @background-color-base;
		}
	}
}
/deep/.el-table::before {
	height: 0;
}
.drawer-footer {
	position: absolute;
	width: 100%;
	left: 0;
	bottom: 0;
	padding: 10px;
	display: flex;
	justify-content: flex-end;
	border-top: 1px solid #f0f1f5;
	background-color: #fff;
}
.body {
	background-color: #fff;
	.reason {
		padding: 10px 12px;
		border: 1px solid #e2e3e8;
		width: 240px;
	}
	.active {
		background-color: fade(@color-p, 8%);
		border: 1px solid @color-p;
	}
}
.shop_img {
	width: 56px;
	height: 56px;
}
.shop-box {
	width: 200px;
}
</style>
